import PickerRound from './PickerRound.vue'

export default PickerRound
